export interface ModalButtonsProps {
    onCancel: () => void;
    submitLabel?: string;
    disabled?: boolean;
}

export function ModalButtons({ onCancel, submitLabel = "Save Changes", disabled = false }: ModalButtonsProps) {
    return (
        <div className="mt-6 flex justify-end gap-3">
            <button
                type="button"
                onClick={onCancel}
                className="btn-secondary"
                disabled={disabled}
            >
                Cancel
            </button>
            <button
                type="submit"
                disabled={disabled}
                className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {submitLabel}
            </button>
        </div>
    );
}
